<template>
    <div id="sensorapp">
        <div class="mainp showPrint">
            <div class="row">
                <div class="mainLeft">
                </div>
                <div class="mainRight">
<!--                    <img src="img/logo.png" class="printLogo"/>-->
                </div>
            </div>
            <br style="clear: both;"/>
            <div class="row" style="margin-top:20px;">
                <div class="mainLeft" style="display:inline;width:65%;_background-color: #aaaaaa">
<!--                    <h2><translate>Sensor & Installationfitting</translate></h2>-->
                </div>
                <div class="mainRight" style="display:inline;width:30%; _background-color: #0054ae;">
<!--                    <div style="margin-left:0%;">-->
<!--                        <translate>Contact")</translate>:<br><br>-->

<!--                        <translate>Georg Fischer Piping Systems Ltd</translate><br>-->
<!--                        Ebnaststrasse 111<br>-->
<!--                        8201 Schaffhausen<br>-->
<!--                        Switzerland<br>-->
<!--                        <br>-->
<!--                        T +41 52 631 11 11<br>-->
<!--                        F +41 52 631 28 00<br>-->
<!--                        info.ps@georgfischer.com<br>-->
<!--                        www.gfps.com<br><br>-->
<!--                    </div>-->
                </div>
            </div>
            <br>
            <br style="clear: both;">
            <div class="row _divShadowP" style="margin:36px; width:95%">
                <div class="row2" style="margin-bottom: 0px">
                    <div class="col50">
                        <div class="myblock">
                            <div class="printHeader"><translate>Units</translate></div>
                            <div id="pUnits" class="printValue"></div>
                        </div>

                        <div class="myblock">
                            <div class="printHeader"><translate>Standard</translate></div>
                            <div id="pStandard" class="printValue"></div>
                        </div>

                        <div class="myblock">
                            <div class="printHeader"><translate>Material</translate></div>
                            <div id="pMaterial" class="printValue"></div>
                        </div>

                        <div class="myblock">
                            <div class="printHeader"><translate>Dimension</translate></div>
                            <div id="pDimension" class="printValue"></div>

                        </div>
                    </div>
                    <!--            <div class="col50">-->
                    <!--            </div>-->
                    <div class="col50">
                        <div class="myblock">
                            <div class="printHeader"><translate>Sensor Type</translate></div>
                            <div id="pSensorType" class="printValue"></div>
                        </div>
                        <!--            </div>-->
                        <!--            <div class="col50">-->
                        <div class="myblock pFilter" id="pFilterFlowMin">
                            <div class="printHeader"><translate>FlowRate min</translate></div>
                            <!--                            <div id="pFilterFlowMinText" class="printValue"></div>-->
                        </div>
                        <div class="myblock pFilter" id="pFilterFlowMax">
                            <div class="printHeader"><translate>FlowRateMax</translate></div>
                            <!--                            <div id="pFilterFlowMaxText" class="printValue"></div>-->
                        </div>
                        <div class="myblock pFilter" id="pFilterFlowSolids">
                            <div class="printHeader"><translate>Liquid contains solids?</translate></div>
                            <div id="pFilterSolidsText" class="printValue"></div>
                        </div>
                    </div>
                </div>

                <br class="clearfix">
                <!--        <br>-->
            </div>
<!--            <br style="clear: both;">-->
<!--            <div id="pYourResult">-->

<!--            </div>-->
            <br style="clear: both;">
            <!--    <br style="clear: both;">-->
<!--            <div style="_position: fixed; bottom:0; margin:36px;">-->
<!--&lt;!&ndash;                <strong>Disclaimer:</strong><br><translate>In case of any queries we recommend to contact GF (info.ps@georgfischer.com). GF will be happy to share with you its extensive practical experience, gained over decades in the field of polymer valves and automation. The technical data are not binding. They neither constitute expressly warranted characteristics nor guaranteed properties nor a guaranteed durability. They are subject to modification. Our General Terms of Sale apply.</translate>&ndash;&gt;-->
<!--            </div>-->
        </div>


        <div class="main hidePrint">
          <div class="pulldowns">

            <div class="halfRow">
              <h2><translate>Sensors</translate></h2>
              <div class="myblock">
                <div class="myLabel">
                  <translate>Sensor Type</translate>
<!--                  <span class="infoI" id="tooltipSensorType" v-tooltip.right="refTooltipSensorType">&nbsp;</span>-->
                  <span class="infoI" id="tooltipSensorType" v-tooltip.right="{ref: 'refTooltipSensorType'}">&nbsp;</span>
                </div>
                <div class="row hidePrint">
                  <Multiselect id="selectSensorsensorType" class="selectSensor" ref="selectsensorType" data-col="sensorType" @changeSelect="changeFitting(this)"></Multiselect>
                  <div ref="refTooltipSensorType" class="tooltip-content">
                    <translate>Tooltip sensorType</translate>
                  </div>
                </div>
              </div>
            </div>

            <div class="halfRow">
                <h2><translate>Installation fitting</translate></h2>
                <div class="myblock">
                    <div class="myLabel">
                        <translate>Standard</translate>
                        <span class="infoI" id="tooltipStandard" v-tooltip.right="{ ref: 'refTooltipStandard' }">&nbsp;</span>
                    </div>
                    <div class="row hidePrint">
                      <Multiselect id="selectstandard" class="selectFitting" ref="selectstandard" data-col="standard" @changeSelect="changeFitting(this)"></Multiselect>
                        <div ref="refTooltipStandard" class="tooltip-content">
                            <translate>Tooltip standard</translate>
                        </div>
                    </div>
                </div>
                <div class="myblock">
                    <div class="myLabel">
                        <translate>Material</translate>
                        <span class="infoI" id="tooltipMaterial" v-tooltip.right="{ ref: 'refTooltipMaterial' }">&nbsp;</span>
                    </div>
                    <div class="row hidePrint">
                      <Multiselect id="selectmaterial" class="selectFitting" ref="selectmaterial" data-col="material" @changeSelect="changeFitting(this)"></Multiselect>
                      <div ref="refTooltipMaterial" class="tooltip-content">
                            <translate>Tooltip material</translate>
                        </div>
                    </div>
                </div>
                <div class="myblock">
                    <div class="myLabel">
                        <translate>Dimension</translate>
                        <span class="infoI" id="tooltipDimension" v-tooltip.right="{ ref: 'refTooltipDimension' }">&nbsp;</span>
                    </div>
                    <div class="row hidePrint">
                      <Multiselect id="selectdn" class="selectFitting" ref="selectdn" data-col="dn" @changeSelect="changeFitting(this)"></Multiselect>
                        <div ref="refTooltipDimension" class="tooltip-content">
                            <translate>Tooltip dimension</translate>
                        </div>
                    </div>
                </div>
            </div>

            <div class="halfRow">
                <h2><translate>Units</translate></h2>
                <div class="myblock">
                    <div class="myLabel">
                        <translate>Units</translate>
                        <span class="infoI" id="tooltipUnits" v-tooltip.right="{ ref: 'refTooltipUnits' }">&nbsp;</span>
                    </div>
                    <div class="row hidePrint">

                      <Multiselect id="selectUnits" :preselect-first="true" ref="selectUnits" @changeSelect="changeFitting()"></Multiselect>

                      <div ref="refTooltipUnits" class="tooltip-content">
                            <translate>Tooltip units</translate>
                        </div>
                    </div>
                </div>
            </div>
            <br class="clearfix"/>



            <div class="_divShadow" style="margin-bottom: 21px;" onclick="return true;">


                <div class="_col50">


                </div>

                <div class="col50">


                    <div class="" id="filter">
                        <div class="myblock filter" id="filter_flow">
                            <div class="row hidePrint _smallMobileMargin">
                                <div style="float:left; padding-top:7px; margin-right: 5px;" class="inputLabel"
                                     id="tMinFlowRange">
                                    <translate>Flow Rate min</translate>
                                </div>
                                <div style="float:left;    width: 27%;">
                                    <input type="text" data-col="flow_flow_min" id="filterFlowMin"
                                           class="selectSensor spinner"
                                           onkeyup="changeFitting()"/>
                                    <span class="infoI" id="tooltipFlow"
                                          title="Tooltip Flow Filter Min">&nbsp;</span>
                                </div>
                                <br style="clear: both;">
                                <div class="row hidePrint _smallMobileMargin">
                                    <div style="float:left; padding-top:7px; margin-right: 5px;" class="inputLabel"
                                         id="tMaxFlowRange">
                                        <translate>Flow Rate max</translate>
                                    </div>
                                    <div style="float:left;    width: 27%;">
                                        <input type="text" data-col="flow_flow_max" id="filterFlowMax"
                                               class="selectSensor spinner"
                                               onkeyup="changeFitting()"/>
                                        <span class="infoI" id="tooltipFlow"
                                              title="Tooltip Flow Filter Max">&nbsp;</span>
                                    </div>
                                </div>
                                <br style="clear: both;">
                                <div class="row hidePrint _smallMobileMargin">

                                    <div style="float:left; padding-top:7px; margin-right: 5px;" class="inputLabel">
                                        <translate>Liquid contains solids?</translate>
                                    </div>
                                    <div style="float:left; width: 200px;padding-top: 8px;">
                                        <div style="float:left; width: 50px;padding-top: 8px;">

                                            <input type="radio" id="flow_liquid_no" name="flow_liquid" value="0"
                                                   data-col="usableWithSolids"
                                                   checked onchange="changeFitting();" class="radioSensor">
                                            <label for="flow_liquid_no">&nbsp;<translate>no</translate></label><br
                                                style="clear: both;">
                                        </div>
                                        <div style="float:left; width: 53px;padding-top: 8px;">

                                            <input type="radio" id="flow_liquid_yes" name="flow_liquid" value="1"
                                                   data-col="usableWithSolids"
                                                   onchange="changeFitting();" class="radioSensor">
                                            <label for="flow_liquid_yes">&nbsp;<translate>yes</translate></label>
                                            <span class="infoI" id="tooltipFlow"
                                                  title="Tooltip Flow Filter usable with solids"
                                            style="margin-top: 2px;">&nbsp;</span><br><br>
                                        </div>
                                    </div>
                                    <br style="clear: both;">

                                </div>
                            </div>
                        </div>
                        <div class="myblock filter" id="filter_pH">
                            <div class="row hidePrint _smallMobileMargin">
                                <div style="float:left; padding-top:7px; margin-right: 5px;" class="inputLabel"
                                     id="tMinFlowRange">
                                    <translate>Process temperature min</translate>
                                </div>
                                <div style="float:left;    width: 27%;">
                                    <input type="text" data-col="ph_processTemperature_min" id="filterPhProcessTemperatureMin"
                                           class="selectSensor spinner"
                                           onkeyup="changeFitting()"/>
                                    <span class="infoI" id="tooltipFlow"
                                          title="Tooltip pH Filter Process temperature Min">&nbsp;</span>
                                </div>
                                <br style="clear: both;">
                                <div class="row hidePrint _smallMobileMargin">
                                    <div style="float:left; padding-top:7px; margin-right: 5px;" class="inputLabel"
                                         id="tMaxFlowRange">
                                        <translate>Process temperature max</translate>
                                    </div>
                                    <div style="float:left;    width: 27%;">
                                        <input type="text" data-col="ph_processTemperature_max" id="filterPhProcessTemperatureMax"
                                               class="selectSensor spinner"
                                               onkeyup="changeFitting()"/>
                                        <span class="infoI" id="tooltipFlow"
                                              title="Tooltip pH Filter Process temperature Max">&nbsp;</span>
                                    </div>
                                </div>
                                <br style="clear: both;">
                                <div style="float:left; padding-top:7px; margin-right: 5px;" class="inputLabel"
                                     id="tMinFlowRange">
                                    <translate>Conducticity min</translate>
                                </div>
                                <div style="float:left;    width: 27%;">
                                    <input type="text" data-col="ph_cunducticity_min" id="filterPhConducticityMin"
                                           class="selectSensor spinner"
                                           onkeyup="changeFitting()"/>
                                    <span class="infoI" id="tooltipFlow"
                                          title="Tooltip pH Filter Conducticity Min">&nbsp;</span>
                                </div>
                                <br style="clear: both;">
                                <div class="row hidePrint _smallMobileMargin">
                                    <div style="float:left; padding-top:7px; margin-right: 5px;" class="inputLabel"
                                         id="tMaxFlowRange">
                                        <translate>Conducticity max</translate>
                                    </div>
                                    <div style="float:left;    width: 27%;">
                                        <input type="text" data-col="ph_cunducticity_max" id="filterPhConducticityMax"
                                               class="selectSensor spinner"
                                               onkeyup="changeFitting()"/>
                                        <span class="infoI" id="tooltipFlow"
                                              title="Tooltip pH Filter Conducticity Max">&nbsp;</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="myblock filter" id="filter_Conductivity">
                            <div class="row hidePrint _smallMobileMargin">
                                <div style="float:left; padding-top:7px; margin-right: 5px;" class="inputLabel"
                                     id="tMinFlowRange">
                                    <translate>Process temperature min</translate>
                                </div>
                                <div style="float:left;    width: 27%;">
                                    <input type="text" data-col="conductivity_processTemperature_min" id="filterConductivityProcessTemperatureMin"
                                           class="selectSensor spinner"
                                           onkeyup="changeFitting()"/>
                                    <span class="infoI" id="tooltipFlow"
                                          title="Tooltip Conductivity Filter Process temperature Min">&nbsp;</span>
                                </div>
                                <br style="clear: both;">
                                <div class="row hidePrint _smallMobileMargin">
                                    <div style="float:left; padding-top:7px; margin-right: 5px;" class="inputLabel"
                                         id="tMaxFlowRange">
                                        <translate>Process temperature max</translate>
                                    </div>
                                    <div style="float:left;    width: 27%;">
                                        <input type="text" data-col="conductivity_processTemperature_max" id="filterConductivityProcessTemperatureMax"
                                               class="selectSensor spinner"
                                               onkeyup="changeFitting()"/>
                                        <span class="infoI" id="tooltipFlow"
                                              title="Tooltip Conductivity Filter Process temperature Max">&nbsp;</span>
                                    </div>
                                </div>
                                <br style="clear: both;">
                                <div style="float:left; padding-top:7px; margin-right: 5px;" class="inputLabel"
                                     id="tMinFlowRange">
                                    <translate>Conducticity min</translate>
                                </div>
                                <div style="float:left;    width: 27%;">
                                    <input type="text" data-col="conductivity_cunducticity_min" id="filterConductivityConducticityMin"
                                           class="selectSensor spinner"
                                           onkeyup="changeFitting()"/>
                                    <span class="infoI" id="tooltipFlow"
                                          title="Tooltip Conductivity Filter Conducticity Min">&nbsp;</span>
                                </div>
                                <br style="clear: both;">
                                <div class="row hidePrint _smallMobileMargin">
                                    <div style="float:left; padding-top:7px; margin-right: 5px;" class="inputLabel"
                                         id="tMaxFlowRange">
                                        <translate>Conducticity max</translate>
                                    </div>
                                    <div style="float:left;    width: 27%;">
                                        <input type="text" data-col="conductivity_cunducticity_max" id="filterConductivityConducticityMax"
                                               class="selectSensor spinner"
                                               onkeyup="changeFitting()"/>
                                        <span class="infoI" id="tooltipFlow"
                                              title="Tooltip Conductivity Filter Conducticity Max">&nbsp;</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="myblock filter" id="filter_orp">
                            <div class="row hidePrint _smallMobileMargin">
                                <div style="float:left; padding-top:7px; margin-right: 5px;" class="inputLabel"
                                     id="tMinFlowRange">
                                    <translate>Process temperature min</translate>
                                </div>
                                <div style="float:left;    width: 27%;">
                                    <input type="text" data-col="orp_processTemperature_min" id="filterOrpProcessTemperatureMin"
                                           class="selectSensor spinner"
                                           onkeyup="changeFitting()"/>
                                    <span class="infoI" id="tooltipFlow"
                                          title="Tooltip ORP Filter Process temperature Min">&nbsp;</span>
                                </div>
                                <br style="clear: both;">
                                <div class="row hidePrint _smallMobileMargin">
                                    <div style="float:left; padding-top:7px; margin-right: 5px;" class="inputLabel"
                                         id="tMaxFlowRange">
                                        <translate>Process temperature max</translate>
                                    </div>
                                    <div style="float:left;    width: 27%;">
                                        <input type="text" data-col="orp_processTemperature_max" id="filterOrpProcessTemperatureMax"
                                               class="selectSensor spinner"
                                               onkeyup="changeFitting()"/>
                                        <span class="infoI" id="tooltipFlow"
                                              title="Tooltip ORP Filter Process temperature Max">&nbsp;</span>
                                    </div>
                                </div>
                                <br style="clear: both;">
                            </div>
                        </div>
                    </div>


                </div>
                <br class="clearfix"/>

            </div>


            <div id="resultsError">
                <translate>No results found.</translate><br><br>
            </div>

            <!--        <a href="#" onclick="$('.layer').show()" style="position:absolute; top:14px; right:20px">more</a>-->
            <div class="layer">
                <a href="#" onclick="$('.layer').hide()">close</a><br><br>
                <div class="col50">
                    <div class="row2">

                        <br class="clearfix"/>

                    </div>
                </div>


                <div class="col50">
                    <div class="row2">
                        <div class="myblock">
                            <div class="row hidePrint _smallMobileMargin">
                                Dimension
                                <br>
                                <select id="selectSensordimension" data-col="dimension">
                                </select>
                                <span class="infoI" id="tooltipType"
                                      title="Tooltip Dimensinon">&nbsp;</span>

                            </div>
                        </div>
                        <br class="clearfix"/>

                    </div>
                </div>
            </div>
            <!--        <br style="clear: both;"><br>-->

        </div>
          <div class="arrow hidePrint" style="margin-left: -6px;">
            <span id="sendEmail" class="bImage" v-on:click="sendMail"><translate>E-Mail</translate></span>
          </div>
          <div class="arrow hidePrint" style="margin-left: -6px;" id="tPrint">
            <span id="doPrint" class="bImage" v-on:click="preparePrint"><translate>Print</translate></span>
          </div>
          <div class="arrow hidePrint" style="margin-left: -6px;">
            <span id="bReset" class="bImage" v-on:click="doReset"><translate>Reset</translate></span>
          </div>
          <br class="clearfix"/>
        </div>


        <div id="resultDiv">
            <span class="results" id="results"></span>
            <br class="clearfix"/>
            <div class="row3 ">
                <div id="sensorResults">
                </div>
            </div>
            <div class="row3">
                <div id="installationFittingResults">
                </div>
            </div>
          <br style="clear: both">
        </div>

        <br style="clear: both">
        <span class="showPrint" style="margin:36px;">
                <strong>Disclaimer:</strong><br><translate>In case of any queries we recommend to contact GF (info.ps@georgfischer.com). GF will be happy to share with you its extensive practical experience, gained over decades in the field of polymer valves and automation. The technical data are not binding. They neither constitute expressly warranted characteristics nor guaranteed properties nor a guaranteed durability. They are subject to modification. Our General Terms of Sale apply.</translate>
            </span>
        <br style="clear: both"><br><br>
    </div>
</template>

<script>
/* eslint-disable */
    import $ from 'jquery'
    import { useGettext } from "@jshmrtn/vue3-gettext";
    import Multiselect from "@/components/multi_select";
    import classList from "@/assets/classList.min.js"
    let $gettext;

    var min = 35, max = 80;
    var diagramPercentValues = [];
    var appgate_ID = "10005H";
    var country = "com";
    var lang = "en"
    // var url = "http://www.gfps.com/appgate/ecat/common_flow/10005H/COM/en/searchview.html?query=";
    // http://www.gfps.com/appgate/ecat/common_flow/[appgate_ID]/[country]/[lang]/catalog.do?action=product-redirect&codeNumber=[Code-Nummer]
    var url = "http://www.gfps.com/appgate/ecat/common_flow/";
    var calcCounter = 0;
    var isFirstInputChange = true;
    var fittingSelected = false, sensorSelected = false;
    var fittingLocked = false, sensorLocked = false;
    var dataFittings, dataSensors, dFittings, dSensors;
    var urlShop ="https://www.google.de";
    var that;
    export default {
        name: "SensorFinder",
        components: {Multiselect},
        props: ['myvm'],
      setup: function () {
        $gettext = useGettext().$gettext;
        window.$gettext = useGettext();
        const language = useGettext();
        return {
          language,
        };
      },
        created: function () {
            var that = this;
            setTimeout(that.preinit, 10);


        },
        beforeCreate: function () {

        },
        methods: {
            preinit: function() {
              console.log("version", "20231005");
             that = this;
              global.myvm = this;
              window.myvm = this;
              $.ajax({
                    type:     "GET",
                    url:      'https://www.gfpstools.com/sensor-installationfitting-tool/vue_get_init_data.php',
                    crossDomain: true,
                    data: {lang:$gettext.current},
                    dataType: "JSON",
                    success: function(data){
                      that.$refs.selectUnits.setOptions([{label:$gettext('metric'), value:'Eu'}, {label:$gettext('imperial'), value:'Us'}]);
                      that.$refs.selectUnits.setPlaceholder(data.placeholder);
                      that.$refs.selectstandard.setOptions(data.standardOptions);
                      that.$refs.selectstandard.setPlaceholder(data.placeholder);
                      that.$refs.selectmaterial.setOptions(data.materialOptions);
                      that.$refs.selectmaterial.setPlaceholder(data.placeholder);
                      that.$refs.selectdn.setOptions(data.dimensionOptions);
                      that.$refs.selectdn.setPlaceholder(data.placeholder);
                      that.$refs.selectsensorType.setOptions(data.sensorOptions);
                      that.$refs.selectsensorType.setPlaceholder(data.placeholder);
                      var test = false;
                      if (that.getUrlParameter("u") != "" && typeof that.getUrlParameter("u") != "undefined")
                      {
                        that.$refs.selectUnits.setSelected(that.getUrlParameter("u").replaceAll("+", " "));
                        test = true;
                      }
                      if (that.getUrlParameter("m") != "" && typeof that.getUrlParameter("m") != "undefined")
                      {
                        that.$refs.selectmaterial.setSelected(that.getUrlParameter("m").replaceAll("+", " "));
                        test = true;
                      }
                      if (that.getUrlParameter("st") != "" && typeof that.getUrlParameter("st") != "undefined")
                      {
                        that.$refs.selectstandard.setSelected(that.getUrlParameter("st").replaceAll("+", " "));
                        test = true;
                      }
                      if (that.getUrlParameter("d") != "" && typeof that.getUrlParameter("d") != "undefined")
                      {
                        that.$refs.selectdn.setSelected(that.getUrlParameter("d").replaceAll("+", "#"));
                        test = true;
                      }
                      if (that.getUrlParameter("f") != "" && typeof that.getUrlParameter("f") != "undefined")
                      {
                        that.$refs.selectsensorType.setSelected(that.getUrlParameter("f").replaceAll("+", " "));
                        test = true;
                      }
                      if(test == true) that.changeFitting();
                    }
                });
            },
            init: function () {

            },
          asyncContent: function (e) {
            //   if(typeof myvm == "undefined") return;
            // setTimeout(function () {
            var text = "test";
            // console.log("e", callee);
            try
            {
              // console.log("myvm" ,$gettext(text));
              return $gettext(text);
            }catch (e)
            {
              console.log("error", e);
            }

            // }, 10);

          },
          buildURL: function ()
            {
              var split = window.location.href.split("/");
              // var split = "https://www.gfps.com/de-de/downloads-tools/online-tools/sensor-fitting-finder.html".split("/");
              // split = "https://www.gfps.com/com/en/downloads-tools/online-tools/sensor-fitting-finder.html".split("/");
              var url = split[0] + "//" + split[2] + "/";
              if (split[3] == "com" || split[3] == "int")
              {
                url += split[3] + "/" + split[4];
              } else
              {
                // url += split[3]+"/"+split[4];
                url += split[3];
              }
              url += ".article.html/";
              return url;
            },
          buildImgURL: function ()
          {
            var split = window.location.href.split("/");
            // split = "https://www.gfps.com/de-de/downloads-tools/online-tools/sensor-fitting-finder.html".split("/");
            // split = "https://www.gfps.com/int/en/downloads-tools/online-tools/sensor-fitting-finder.html".split("/");
            var url = split[0] + "//" + split[2] + "/";
            if (split[3] == "com" || split[3] == "int")
            {
              url += split[3] + "/" + split[4];
            } else
            {
              // url += split[3]+"/"+split[4];
              url += split[3];
            }
            url += ".image.html/";
            return url;
          },
            buildSensor: function (sensor) {
              var item = "<div class=\"resultHeaderWrapper resultsensor\" id='resultsensor"+sensor.sensorId+"'>\n" +
                  "                    <div class=\"resultHeader\" onclick='myvm.selectSensor("+sensor.sensorId+")'>\n" +
                  "                        <img class=\"resultImg\" src=\""+this.buildImgURL()+sensor.sensorCode+"\">";
                item += "<div class=\"resultProductName\">"+sensor.sensorName+"</div>";
                item += "</div>\n" +
                    "                    <table class=\"resultTable\" cellspacing=\"0\" cellpadding=\"5\">\n" +
                    "                        <tr>\n" +
                    "                            <th>Code</th>\n" +
                    "                            <th>MFR#</th>\n" +
                    "                            <th>Body</th>\n" +
                    "                            <th>Pin</th>\n" +
                    "                            <th>Sensor Type</th>\n" +
                    "                        </tr>";
                var rowStepper = 0;
                for (var j = 0; j < sensor.similarSensors.length; ++j)
                {
                    item += "<tr class=\"resultTableRow"+(rowStepper++%2)+"\">\n" +
                        "                            <td><a href=\""+this.buildURL()+sensor.similarSensors[j].code+"\" target=\"_blank\">" +sensor.similarSensors[j].code+"</a></td>\n" +
                        "                            <td>"+sensor.similarSensors[j].mfr+"</td>\n" +
                        "                            <td>"+sensor.similarSensors[j].body+"</td>\n" +
                        "                            <td>"+sensor.similarSensors[j].pin+"</td>\n" +
                        "                            <td>"+sensor.similarSensors[j].sensorLengthFlow+"</td>\n" +
                        "                        </tr>";
                }
                item += " </table>\n" +
                    "                </div>";
                return item;
            },
            buildFitting: function(fitting){
              var item = "<div class=\"resultHeaderWrapper resultfitting\" id='resultfitting"+fitting.id+"'>\n" +
                  // "                    <div class=\"resultHeader\" onclick='myvm.$options.components.sensorFinder.methods.selectFitting("+fitting.id+")'>\n" +
                  "                    <div class=\"resultHeader\" onclick='myvm.selectFitting("+fitting.id+")'>\n" +
                  "                        <img class=\"resultImg\" src=\"" +  this.buildImgURL()+fitting.code+"\">";
                item += "<div class=\"resultProductName\">"+fitting.name+"</div>";
                item += "</div>\n" +
                    "                    <table class=\"resultTable\" cellspacing=\"0\" cellpadding=\"5\">\n" +
                    "                        <tr>\n" +
                    "                            <th>Code</th>\n" +
                    "                            <th>dn</th>\n" +
                    "                            <th>Material</th>\n" +
                    "                            <th>Remark</th>\n" +
                    "                        </tr>";
                var rowStepper = 0;
                for (var j = 0; j < fitting.similarFittings.length; ++j)
                {
                    item += "<tr class=\"resultTableRow"+(rowStepper++%2)+"\">\n" +
                        "                            <td><a href=\""+this.buildURL()+fitting.similarFittings[j].code+"\" target=\"_blank\">"+fitting.similarFittings[j].code+"</a></td>\n" +
                        "                            <td>"+fitting.similarFittings[j].ddn+"</td>\n" +
                        "                            <td>"+fitting.similarFittings[j].material+"</td>\n" +
                        "                            <td>"+fitting.similarFittings[j].remarkFlow + " " + fitting.similarFittings[j].remarkPhOrp+"</td>\n" +
                        "                        </tr>";
                }
                item += " </table>\n" +
                    "                </div>";
                return item;
            },
            changeFitting: function (obj, type) {

                if (typeof type == "undefined")
                {
                    type  = "";
                }
                sensorLocked = false;
                fittingLocked = false;
                isFirstInputChange = false;
                $(".resetSelection").hide();
                $("#tPrint").hide();
                var sendData = {};
                var sendDataSensor = {};
                that = this;
              $("#sensorResults").empty();
              $("#installationFittingResults").empty();
              $(".selectFitting").each(function () {

                    if (typeof that.$refs["select"+$(this).data("col")] != "undefined" && that.$refs["select"+$(this).data("col")].val() != "") sendData[$(this).data("col")] = that.$refs["select"+$(this).data("col")].val();
                });
                $(".selectSensor").each(function () {
                    if (typeof that.$refs["select"+$(this).data("col")] != "undefined" && that.$refs["select"+$(this).data("col")].val() != "") sendDataSensor[$(this).data("col")] = that.$refs["select"+$(this).data("col")].val();
                });
                sendDataSensor["usableWithSolids"] = $("input[name='flow_liquid']:checked").val();
                if ($.isEmptyObject(sendData) && $.isEmptyObject(sendDataSensor))
                {
                    $("#installationFittingResults").empty();
                    // $("#sensorResults").empty();
                    // return;
                }
                if($(obj).attr('id') == "selectSensorsensorType"){
                    $("#filter").hide();
                    $(".openParams").text("open additional parameters");
                }
                if ($("#filterFlowMin").val() != "")
                {
                    var mins = calcFilterFlowVal($("#filterFlowMin").val());
                    sendDataSensor["flow_flow_min"] = mins["flow"];
                    sendDataSensor["flow_speed_min"] = mins["speed"];
                }
                if ($("#filterFlowMax").val() != "")
                {
                    var mins = calcFilterFlowVal($("#filterFlowMax").val());
                    sendDataSensor["flow_flow_max"] = mins["flow"];
                    sendDataSensor["flow_speed_max"] = mins["speed"];
                }

                // console.log("$(this).id", $(obj));
                var data = {};
                data["fittings"] = sendData;
                data["sensors"] = sendDataSensor;
                data["units"] = that.$refs.selectUnits.val()==""?"Eu":that.$refs.selectUnits.val();
                data["urlShop"] = urlShop;
                data["lang"] = window.$gettext.current;  //todo
              console.log("gettext", window.$gettext.current);
                if ($("#filter").is(":hidden"))
                {
                    data["additionalOptions"] = 0;
                } else
                {
                    data["additionalOptions"] = 1;
                }
                if ($("#selectdn").val() != "")
                {
                    $("#filterFlowMin").prop("disabled", false);
                    $("#filterFlowMax").prop("disabled", false);
                    $("#tMinFlowRange").css("color", "#000");
                    $("#tMaxFlowRange").css("color", "#000");
                } else
                {
                    $("#filterFlowMin").prop("disabled", true);
                    $("#filterFlowMax").prop("disabled", true);
                    $("#tMinFlowRange").css("color", "#bfbfbf");
                    $("#tMaxFlowRange").css("color", "#bfbfbf");
                }

                var that = this;

                $.ajax({
                    url: "https://www.gfpstools.com/sensor-installationfitting-tool/vue3_get_data.php",
                    data: {sendData: data},
                    dataType: 'json',
                    crossDomain: true,
                    method: 'get'
                }).done(function (data) {
                    $("#installationFittingResults").empty();
                    $("#resultDiv").show();
                    $("#sensorResults").empty();
                    $("#resultsError").hide();
                    $("#tMinFlowRange").text("Flow rate min");
                    $("#tMaxFlowRange").text("Flow rate max");
                    if (data.fittings.length == 0)
                    {
                        $("#resultDiv").hide();
                        $("#resultsError").show();
                        return;
                    }
                    dataFittings = data.fittings;
                    dataSensors = data.sensors;
                    dSensors = data.returnSensorsData;
                    dFittings = data.returnFittingsData;
                    var item;

                    $("#sensorResults").append("<h2>"+$gettext("Sensors")+"</h2>");
                    $("#installationFittingResults").append("<h2>"+$gettext("Fittings")+"</h2>");
                    for (var i = 0; i < dSensors.length; ++i)
                    {
                        $("#sensorResults").append(that.buildSensor(dSensors[i]));
                    }

                    for (i = 0; i < dFittings.length; ++i)
                    {
                        $("#installationFittingResults").append(that.buildFitting(dFittings[i]));
                    }

                    var selVal = $("#selectmaterial").val()
                    var selectData = data.selects.selectMaterial;
                    var selected;
                  that.$refs.selectstandard.setOptions(data.selects.selectStandard);
                  that.$refs.selectmaterial.setOptions(data.selects.selectMaterial);
                  that.$refs.selectdn.setOptions(data.selects.selectDimension);
                  that.$refs.selectsensorType.setOptions(data.selects.selectSensorType);
                    // console.log("selectData", selectData);
                    // $("#selectmaterial").empty();
                    // for (var i = 0; i < selectData.length; ++i)
                    // {
                    //     if (selVal == selectData[i] || selectData.length == 2)
                    //     {
                    //         selected = "selected";
                    //     } else
                    //     {
                    //         selected = "";
                    //     }
                    //     if (i == 0)
                    //     {
                    //         $("#selectmaterial").append('<option value="" ' + selected + '>' + selectData[i] + '</option>');
                    //     } else
                    //     {
                    //
                    //         $("#selectmaterial").append('<option value="' + selectData[i] + '" ' + selected + '>' + selectData[i] + '</option>');
                    //     }
                    // }
                    // selVal = $("#selectdn option:selected").text();
                    // selectData = data.selects.selectDimension;
                    // $("#selectdn").empty();
                    //
                    // for (i = 0; i < selectData.length; ++i)
                    // {
                    //     if (selVal == selectData[i]["label"] || selectData.length == 2)
                    //     {
                    //         selected = "selected";
                    //     } else
                    //     {
                    //         selected = "";
                    //     }
                    //     if (i == 0)
                    //     {
                    //         $("#selectdn").append('<option value="" ' + selected + '>' + selectData[i]["label"] + '</option>');
                    //     } else
                    //     {
                    //
                    //         $("#selectdn").append('<option value="' + selectData[i]["val"] + '" ' + selected + '>' + selectData[i]["label"] + '</option>');
                    //     }
                    // }
                    // selVal = $("#selectstandard").val()
                    // selectData = data.selects.selectStandard;
                    // // console.log("selectData", selectData);
                    // $("#selectstandard").empty();
                    //
                    // for (i = 0; i < selectData.length; ++i)
                    // {
                    //     if (selVal == selectData[i] || selectData.length == 2)
                    //     {
                    //         selected = "selected";
                    //     } else
                    //     {
                    //         selected = "";
                    //     }
                    //     if (i == 0)
                    //     {
                    //         $("#selectstandard").append('<option value="" ' + selected + '>' + selectData[i] + '</option>');
                    //     } else
                    //     {
                    //
                    //         $("#selectstandard").append('<option value="' + selectData[i] + '" ' + selected + '>' + selectData[i] + '</option>');
                    //     }
                    // }
                    //
                    // selVal = $("#selectSensorsensorType").val()
                    // selectData = data.selects.selectSensorType;
                    // // console.log("selectData", selectData);
                    // $("#selectSensorsensorType").empty();
                    //
                    // for (i = 0; i < selectData.length; ++i)
                    // {
                    //     if (selVal == selectData[i] || selectData.length == 2)
                    //     {
                    //         selected = "selected";
                    //     } else
                    //     {
                    //         selected = "";
                    //     }
                    //     if (i == 0)
                    //     {
                    //         $("#selectSensorsensorType").append('<option value="" ' + selected + '>' + selectData[i] + '</option>');
                    //     } else
                    //     {
                    //
                    //         $("#selectSensorsensorType").append('<option value="' + selectData[i] + '" ' + selected + '>' + selectData[i] + '</option>');
                    //     }
                    // }
                    switch ($("#selectSensorsensorType").val())
                    {
                        case "Flow":
                        case "pH":
                        case "Conductivity":
                        case "ORP":
                            $(".openParams").show();
                            //if ($(".openParams").text() =="<?php //echo _("- close additional parameters");?>//")
                            //{
                            //    $(".openParams").text("<?php //echo _("+ open additional parameters");?>//");
                            //} else
                            //{
                            //    $(".openParams").text("<?php //echo _("- close additional parameters");?>//");
                            //}
                            break;
                        case "pH":
                            $(".openParams").show();
                            //if ($(".openParams").text() =="<?php //echo _("- close additional parameters");?>//")
                            //{
                            //    $(".openParams").text("<?php //echo _("+ open additional parameters");?>//");
                            //} else
                            //{
                            //    $(".openParams").text("<?php //echo _("- close additional parameters");?>//");
                            //}
                            break;
                        default:
                            $(".openParams").hide();
                            break;
                    }

                });
            },
            selectSensor: function(sid)
            {
                if (sensorLocked)
                {
                    $("#sensorResults").empty();
                    $("#sensorResults").append("<h2>Sensors</h2>");
                    // console.log("dSensors", dSensors);
                    for (var i = 0; i < dSensors.length; ++i)
                    {
                        $("#sensorResults").append(this.buildSensor(dSensors[i]));
                    }
                    sensorLocked = false;
                    return;
                }
                sensorLocked = true;
                $(".resultsensor").hide();
                $("#resultsensor"+sid).show();
                $("#resultsensor"+sid).find(".resultTable").show();

                if (fittingLocked == true && sensorLocked == true)
                {
                    $("#tPrint").show();
                }
                if (fittingLocked)
                {
                    return;
                }
                var type = $("#sensor_" + sid + "").data("type");

                var sendData = {};
                var sendDataSensor = {};
               // var that = myvm.$children[0].$children[0];
              var that = this;
              $(".selectFitting").each(function () {
                if (typeof that.$refs["select"+$(this).data("col")] != "undefined" && that.$refs["select"+$(this).data("col")].val() != "") sendData[$(this).data("col")] = that.$refs["select"+$(this).data("col")].val();
              });
              $(".selectSensor").each(function () {
                if (typeof that.$refs["select"+$(this).data("col")] != "undefined" && that.$refs["select"+$(this).data("col")].val() != "") sendDataSensor[$(this).data("col")] = that.$refs["select"+$(this).data("col")].val();
              });
                sendDataSensor["usableWithSolids"] = $("input[name='flow_liquid']:checked").val();
                if ($.isEmptyObject(sendDataSensor))
                {
                    // $("#installationFittingResults").empty();
                    $("#sensorResults").empty();
                    return;
                }
                var data = {};
                data["fittings"] = sendData;
                data["sensors"] = sendDataSensor;
                data["units"] = that.$refs.selectUnits.val();
                data["urlShop"] = urlShop;
                if ($("#filter").is(":hidden"))
                {
                    data["additionalOptions"] = 0;
                } else
                {
                    data["additionalOptions"] = 1;
                }
                var that = this;
                $.ajax({
                    url: "https://www.gfpstools.com/sensor-installationfitting-tool/vue_get_fittings.php",
                    data: {sid: sid, type: type, sendData: data},
                    dataType: 'JSON',
                    crossDomain: true,
                    method: 'get'
                }).done(function (data) {
                    $("#installationFittingResults").empty();
                    $("#installationFittingResults").append("<h2>Fittings</h2>");
                    $("#resultDiv").show();
                    dFittings = data.returnFittingsData;


                    for (var i = 0; i < dFittings.length; ++i)
                    {
                        $("#installationFittingResults").append(that.buildFitting(dFittings[i]));
                    }
                    if (dFittings.length == 1)
                    {
                        $(".resultfitting").find(".resultHeader").click();
                    }
                });
            },
            selectFitting: function(fid)
            {

                if (fittingLocked)
                {
                    $("#installationFittingResults").empty();
                    $("#installationFittingResults").append("<h2>Fittings</h2>");

                    for (var i = 0; i < dFittings.length; ++i)
                    {
                        $("#installationFittingResults").append(this.buildFitting(dFittings[i]));
                    }
                    fittingLocked = false;
                    return;
                }
                fittingLocked = true;
                $(".resultfitting").hide();
                $("#resultfitting"+fid).show();
                $("#resultfitting"+fid).find(".resultTable").show();
                $("#resultDiv").show();
                if (fittingLocked == true && sensorLocked == true)
                {
                    $("#tPrint").show();
                }
                if(dataFittings.length > 1) $("#resetSelectionFittings").show();
                if (sensorLocked) return;
                var sendData = {};
                var sendDataSensor = {};
               // var that = myvm.$children[0].$children[0];
               var that = this;
              $(".selectFitting").each(function () {
                if (typeof that.$refs["select"+$(this).data("col")] != "undefined" && that.$refs["select"+$(this).data("col")].val() != "") sendData[$(this).data("col")] = that.$refs["select"+$(this).data("col")].val();
              });
              $(".selectSensor").each(function () {
                if (typeof that.$refs["select"+$(this).data("col")] != "undefined" && that.$refs["select"+$(this).data("col")].val() != "") sendDataSensor[$(this).data("col")] = that.$refs["select"+$(this).data("col")].val();
              });
                sendDataSensor["usableWithSolids"] = $("input[name='flow_liquid']:checked").val();
                if ($.isEmptyObject(sendDataSensor))
                {
                    // $("#installationFittingResults").empty();
                    $("#sensorResults").empty();
                    return;
                }
                var data = {};
                data["fittings"] = sendData;
                data["sensors"] = sendDataSensor;
                data["units"] = that.$refs.selectUnits.val();
                if ($("#filter").is(":hidden"))
                {
                    data["additionalOptions"] = 0;
                } else
                {
                    data["additionalOptions"] = 1;
                }
                // alert("vor ajax");
                var that = this;
                $.ajax({
                    url: "https://www.gfpstools.com/sensor-installationfitting-tool/vue_get_sensors.php",
                    data: {fid: fid, sendData: data},
                    dataType: 'JSON',
                    method: 'get',
                    crossDomain: true
                }).done(function (data) {
                    // $("#installationFittingResults").empty();
                    // alert("nach ajax");

                    $("#sensorResults").empty();
                    dSensors = data.returnSensorsData;

                    $("#sensorResults").append("<h2>Sensors</h2>");

                    for (var i = 0; i < dSensors.length; ++i)
                    {
                        $("#sensorResults").append(that.buildSensor(dSensors[i]));
                    }
                    if (dSensors.length == 1)
                    {
                        $(".resultsensor").find(".resultHeader").click();
                    }
                });
            },
            preparePrint: function()
            {
                $("#pUnits").text(this.$refs.selectUnits.val()=="Eu"?"metric":"imperial");
                $("#pStandard").text(this.$refs.selectstandard.val());
                $("#pMaterial").text(this.$refs.selectmaterial.val());
                $("#pDimension").text(this.$refs.selectdn.val());
                $("#pSensorType").text(this.$refs.selectsensorType.val());
                $(".pFilter").hide();
                var theight = Math.max($("#sensorResults").height(), $("#installationFittingResults").height());
                // console.log("theight", theight);
                // $("#sensorResults").height(theight+"px");
                // $("#installationFittingResults").height(theight+"px");
                switch ($("#selectSensorsensorType").val())
                {
                    case "Flow":
                        if($("#filter").is(":hidden")){
                            $("#pFilterFlowMin").hide();
                            $("#pFilterFlowMax").hide();
                            $("#pFilterFlowSolids").hide();
                        } else {
                            $("#pFilterFlowMin").show();
                            $("#pFilterFlowMax").show();
                            $("#pFilterFlowSolids").show();
                            $("#pFilterFlowMinText").text($("#filterFlowMin").val());
                            $("#pFilterFlowMaxText").text($("#filterFlowMax").val());
                            $("#pFilterSolidsText").text($("input[name='flow_liquid']:checked").val()==0?"No":"Yes");

                        }
                        break;
                }

                // $("#pYourResult").empty();
                // $("#pYourResult").append($("#sensorResults").html());
                // $("#pYourResult").append("<br style='clear: both;'><br style='float:left;'> " + $("#installationFittingResults").html() + "<br style='clear: both;'><br style='clear: both;'>");


                $("#pYourResult .resetSelection").remove();
                setTimeout('window.print()', 1500);
                window.onafterprint = function(){
                    $("#pYourResult").empty();
                }
            },
            sendMail: function()
            {
                var mailSubject = window.$gettext("GF Piping Systems: Sensor Installation fitting");
                var mailBody1 = window.$gettext("I thought you might find this information interesting:")+'%0D%0A';
                var mailBody2 = "%0D%0A%0D%0A"+window.$gettext("Disclaimer: %0D%0AThe technical data are not binding. They neither constitute expressly warranted characteristics nor guaranteed properties nor a guaranteed durability. They are subject to modification. Our General Terms of Sale apply.");
              console.log("test", this.$refs.selectsensorType.val());
                var rUnits = this.$refs.selectUnits.val(),
                    rSolids = $("input[name='flow_liquid']:checked").val(),
                    selectMaterialVal = this.$refs.selectmaterial.val().replaceAll(" ", "+"),
                    selectStandardVal = this.$refs.selectstandard.val().replaceAll(" ", "+"),
                    selectDimensionVal = this.$refs.selectdn.val().replaceAll("#", "+"),
                    selectSensorTypeVal = this.$refs.selectsensorType.val().replaceAll(" ", "+"),
                    filterFlowMin = $("#filterFlowMin").val().replaceAll(" ", "+"),
                    filterFlowMax = $("#filterFlowMax").val().replaceAll(" ", "+"),

                    filterConductivityProcessTemperatureMin = $("#filterConductivityProcessTemperatureMin").val(),
                    filterConductivityProcessTemperatureMax = $("#filterConductivityProcessTemperatureMax").val(),
                    filterConductivityConducticityMin = $("#filterConductivityConducticityMin").val(),
                    filterConductivityConducticityMax = $("#filterConductivityConducticityMax").val(),
                    filterOrpProcessTemperatureMin = $("#filterOrpProcessTemperatureMin").val(),
                    filterOrpProcessTemperatureMax = $("#filterOrpProcessTemperatureMax").val(),
                    filterPhProcessTemperatureMin = $("#filterPhProcessTemperatureMin").val(),
                    filterPhProcessTemperatureMax = $("#filterPhProcessTemperatureMax").val(),
                    filterPhConducticityMin = $("#filterPhConducticityMin").val(),
                    filterPhConducticityMax = $("#filterPhConducticityMax").val(),
                    additionalOptions;
                if($("#filter").is(":hidden")){
                    additionalOptions = 0;
                } else {
                    additionalOptions = 1;
                }
                var country = "";
                var langshort = "";
                var mailurl = top.location.protocol + '//' + top.location.host + top.location.pathname+'?m=';
                //location.href = "mailto:?to=&subject="+mailSubject+"&body="+mailBody1+"https://gfpstools.com/sensor-installationfitting-tool/?m=" + selectMaterialVal + "%26st=" + selectStandardVal + "%26so=" + rSolids + "%26ao=" + additionalOptions + "%26u=" + rUnits + "%26ff1=" + filterFlowMin + "%26ff2=" + filterFlowMax + "%26f=" + selectSensorTypeVal + "%26d=" + selectDimensionVal + "%26fc1=" + filterConductivityProcessTemperatureMin + "%26fc2=" + filterConductivityProcessTemperatureMax + "%26fc3=" + filterConductivityConducticityMin + "%26fc4=" + filterConductivityConducticityMax + "%26fp1=" + filterPhProcessTemperatureMin + "%26fp2=" + filterPhProcessTemperatureMax + "%26fp3=" + filterPhConducticityMin + "%26fp4=" + filterPhConducticityMax + "%26fo1=" + filterOrpProcessTemperatureMin + "%26fo2=" + filterOrpProcessTemperatureMax + "%26lang=" + lang+mailBody2;
                location.href = "mailto:?to=&subject="+mailSubject+"&body="+mailBody1+mailurl + selectMaterialVal + "%26st=" + selectStandardVal + "%26so=" + rSolids + "%26ao=" + additionalOptions + "%26u=" + rUnits + "%26ff1=" + filterFlowMin + "%26ff2=" + filterFlowMax + "%26f=" + selectSensorTypeVal + "%26d=" + selectDimensionVal + "%26fc1=" + filterConductivityProcessTemperatureMin + "%26fc2=" + filterConductivityProcessTemperatureMax + "%26fc3=" + filterConductivityConducticityMin + "%26fc4=" + filterConductivityConducticityMax + "%26fp1=" + filterPhProcessTemperatureMin + "%26fp2=" + filterPhProcessTemperatureMax + "%26fp3=" + filterPhConducticityMin + "%26fp4=" + filterPhConducticityMax + "%26fo1=" + filterOrpProcessTemperatureMin + "%26fo2=" + filterOrpProcessTemperatureMax + "%26lang=" + lang+mailBody2;
            },
          getUrlParameter: function (sParam) {
            var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;
            for (i = 0; i < sURLVariables.length; i++)
            {
              sParameterName = sURLVariables[i].split('=');
              if (sParameterName[0] === sParam)
              {
                return sParameterName[1] === undefined ? true : sParameterName[1];
              }
            }
          },
          doReset: function () {
            var that = this;
            that.$refs.selectsensorType.reInit();
            that.$refs.selectUnits.reInit();
            that.$refs.selectstandard.reInit();
            that.$refs.selectmaterial.reInit();
            that.$refs.selectdn.reInit();
            $("#sensorResults").empty();
            $("#installationFittingResults").empty();
            $("#doPrint").hide();
            that.preinit();
          },
        }
    }
</script>
<style scoped>
    @font-face {
        font-family: "DINNextLTW05-Regular";
        src: url("../assets/DINNextLTW05-Regular.eot?#iefix");
        src:
                url("../assets/DINNextLTW05-Regular.eot?#iefix") format("eot"),
                url("../assets/DINNextLTW05-Regular.woff2") format("woff2"),
                url("../assets/DINNextLTW05-Regular.woff") format("woff"),
                url("../assets/DINNextLTW05-Regular.ttf") format("truetype");
    }

    @font-face {
        font-family: "GlyphaLTW05-65Bold";
        src: url("../assets/GlyphaLTW05-65Bold.eot?#iefix");
        src:
                url("../assets/GlyphaLTW05-65Bold.eot?#iefix") format("eot"),
                url("../assets/GlyphaLTW05-65Bold.woff2") format("woff2"),
                url("../assets/GlyphaLTW05-65Bold.woff") format("woff"),
                url("../assets/GlyphaLTW05-65Bold.ttf") format("truetype");
    }

    @font-face {
        font-family: "DINNextLTW01-Medium";
        src: url("../assets/DINNextLTW01-Medium.eot?#iefix");
        src:
                url("../assets/DINNextLTW01-Medium.eot?#iefix") format("eot"),
                url("../assets/DINNextLTW01-Medium.woff2") format("woff2"),
                url("../assets/DINNextLTW01-Medium.woff") format("woff"),
                url("../assets/DINNextLTW01-Medium.ttf") format("truetype");
    }



    h1, a {
        font-size: 16px;
        font-weight: bold;
        color: #0054ae;
        text-decoration: none !important;
    }
    .selectWrapper {
        color: #000;
        font-size: 16px;
        line-height: 1.5;
        -webkit-font-smoothing: antialiased;
        box-sizing: border-box;
        flex-basis: 100%;
        margin-top: 8px;
        position: relative;
    }
    .selectWrapper::after {
        content: "";
        display: block;
        background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 7.6l-6-6L1.6 0 6 4.4 10.4 0 12 1.6l-6 6z' fill='%2333ADFF' fill-rule='evenodd'/%3E%3C/svg%3E");
        background-position: center;
        background-size: 0.75rem 0.5rem;
        background-repeat: no-repeat;
        height: 2.5rem;
        pointer-events: none;
        position: absolute;
        right: 1rem;
        top: 0;
        width: 0.75rem;
        font-family: DINNextLTW05-Regular,sans-serif;
    }
    select {
        width: 90%;
        margin-top: 5px;
    }
    input, select {
        -webkit-font-smoothing: antialiased;
        box-sizing: border-box;
        -webkit-appearance: none;
        background-color: #f0f0f0;
        border: .1875rem solid #f0f0f0;
        border-radius: 0;
        display: block;
        font-family: DINNextLTW05-Regular,sans-serif;
        font-size: 1.125rem;
        height: 2.5rem;
        padding: .3125rem 2.375rem .3125rem .5rem;
        width: 100%;
        outline: none;
    }
    input[type="text"] {
        width: 78%;
        margin-top: 5px;
    }

    input[type="text"] {
        margin-bottom: 10px;
    }

    input[type="number"] {
        margin-top: 2px;
        margin-right: 2px;
        margin-bottom: 18px;
    }

    label {
        _font-size: 10px;
    }

    h2 {
        font-family: "DINNextLTW05-Regular", sans-serif;
        /*margin-top: -12px !important;*/
        font-size: 20px;
        color: #0065A7;
    }

    .openParams, .openParams2 {
        color: #999;
        font-size: 11px;
        /*margin-top:4px;*/
        cursor: pointer;
    }

    #filter {
        display: none;
    }

    .filter {
        display: none;
    }

    .openParams {
        display: none;
    }

    .resultRemark {
        display: inline-block;
        /*width: 400px;*/
        width: 200px;
        vertical-align: text-top;
        margin-bottom: 2px;
    }

    .textlink {
        display: inline-block;
    }

    #resultsError {
        display: none;
        color: #ff0000;
        /*background-color: #ff0000;*/
        /*font-weight: bold;*/
        /*width: 80%;*/
        /*text-align: center;*/
        /*display: block;*/
        font-size: 1.5em;
        -webkit-margin-before: 0.83em;
        -webkit-margin-after: 0.83em;
        -webkit-margin-start: 0px;
        -webkit-margin-end: 0px;
        font-weight: bold;
        /*padding-top: 20px;*/
        /*padding-bottom: 20px;*/
    }

    .linkIcon {
        cursor: pointer;
    }

    .hidePrint {
        display: block;
    }

    .hide {
        display: none;
    }

    .showPrint {
        display: none;
    }

    .main {
        width: 90vw;
        margin-left: auto;
        margin-right: auto;
        max-width: 1280px;
        border: 1px solid #bbb;
        padding: 20px;
        font-family: DINNextLTW05-Regular,Arial,sans-serif;
    }
    #resultDiv {
        width: 90vw;
        margin-left: auto;
        margin-right: auto;
        max-width: 1280px;
    }
    .mainLeft {
        width: 40%;
        display: inline;
        float: left;
    }

    .mainCenter {
        margin-left: 2%;
        display: inline;
        float: left;
    }

    .mainRight {
        width: 52%;
        margin-left: 2%;
        display: inline;
        float: left;
        margin-right: 3%;
        /*padding:20px;*/
    }

    .inputLabel {
        width: 90px;
    }

    .divShadow {
        margin-bottom: 36px;
        border: 1px solid #eaeaea;
        border-left: 1px solid #f6f6f6;
        -webkit-box-shadow: 1px 1px 3px #aaa;
        -moz-box-shadow: 1px 1px 3px #aaa;
        box-shadow: 1px 1px 3px #aaa;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 10px;
    }

    .divShadowP {
        margin-bottom: 6px;
        /*margin-left: 10px;*/
        border: 1px solid #000;
        /*border-left: 1px solid #f6f6f6;*/
        /*width:785px;*/
        padding-left: 10px;
        padding-top: 8px;
    }

    .printValue {
        margin-top: 4px;
        margin-bottom: 10px;
    }

    .pInline {
        display: none !important;
        width: 100px;
        float: left;
    }

    .orangeBox {
        padding: 6px 12px 6px 12px;
        color: #ffffff;
        background-color: #F07C0B;
        margin-left: 20px;
        margin-right: 20px;
    }

    .resultText {
        color: #F07C0B;
    }

    .resultTextBold {
        font-weight: bold;
    }

    .row {
        width: 100%;
        margin-bottom: 20px;
    }

    .halfRow {
        display: inline;
        float: left;
        width: 32%;
        margin-right: 1.5%;
    }
    .halfRow:nth-child(3) {
        margin-right: 0;
    }
    .row80 {
        width: 80%;
        display: inline;
        float: left;
    }

    .row40 {
        width: 45%;
        display: inline;
        float: left;
    }

    .row90 {
        width: 90%;
        display: inline;
        float: left;
        margin-bottom: 20px;
    }

    .row20 {
        width: 10%;
        display: inline;
        float: left;
        margin-top: 3px;
    }

    .row20::after {
        clear: both;
    }

    .plus {
        background: #ff7e00 url(../assets/icons.png) no-repeat -85px -3297px;
        width: 16px;
        height: 16px;
        margin-top: 14px;
        cursor: pointer;
        margin-left: 124%;
    }

    .printminus {
        background: #f07d0f url('../assets/icons.png') -85px -3397px no-repeat !important;
    }

    .infoI {
        background: url(../assets/infoI.png) no-repeat;
        bottom: 1px;
        height: 20px;
        width: 20px;
        cursor: pointer;
        z-index: 1000;
        vertical-align: sub;
        float: right;
        margin-top: 0px;
    }

    .tooltip {
        position: relative;
        width: 1px;
        height: 1px;
        display: inline;
        cursor: pointer;
    }

    .tipp {
        position: absolute;
        display: none;
        padding: 10px;
        /*border:1px #000 solid;*/
        background: #ffffff;
        top: 0;
        left: 10px;
        cursor: pointer;
        z-index: 999999;

        min-width: 125px;
        -webkit-box-shadow: 1px 1px 3px #aaa;
        -moz-box-shadow: 1px 1px 3px #aaa;
        box-shadow: 1px 1px 3px #aaa;
    }

    .inputNumber {
        width: 60%
    }

    #outerImage {
        position: relative;
    }

    #locatorLeft {

    }

    .locator {
        /*height: 100%;*/
        width: 6px;
        /*background-color: #ff0000 !important;*/
        /*border: 4px solid rgba(0, 0, 255, 0.0);*/
        position: absolute;
        top: 3%;
        left: 11.67%;
        height: 79%;
        z-index: 100;
    }

    .openingRed {
        height: 80%;
        background-color: #ff0000 !important;
        opacity: 0.0;

        position: absolute;
        z-index: 10;
        top: 3%;
    }

    .arrow {
        /*background: #ffffff url(../assets/icons.png) no-repeat 7px 4px;*/
        /*padding-left: 20px;*/
        font-size: 16px;
        font-weight: bold;
        color: #0054ae;
        float: left;
        width: 133px;
    }

    .results {
        font-size: 13px;
        line-height: 24px;
    }

    .clearfix {
        clear: both;
    }

    .row2 {
        width: 100%;
        float: left;
    }

    .row3 {
        width: 47%;
        float: left;
        margin-right: 3%;
    }
    .row3:last-child {
        margin-right: 0;
    }
    #sensorResults {
        margin-bottom: 30px;
    }
    .myLabel {
        font-size: 16px;
        text-align: left;
    }
    .myblock {
        display: inline;
        float: left;
        width: 100%;
        margin-right: 3%;
    }

    .prodHighlight {
        /*border: 2px solid #0054ae;*/
        margin-right: 4px;
    }

    input[type="radio"] {
        margin-left: 0;
    }

    .layer {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        background-color: #f6f6f6;
        padding: 10px;
    }
    #sendEmail:before {
        content: url("../assets/email.png");
        margin-right: 8px;
        vertical-align: middle;
    }
    #sendEmail {
        color: #00abfe;
        font-size: 16px;
        cursor: pointer;
        font-family: "DINNextLTW01-Medium", Arial;
    }


    #doPrint {
       color: #00abfe;
       font-size: 16px;
       cursor: pointer;
       margin-right: 35px;
       font-family: "DINNextLTW01-Medium", Arial;
     }
    #doPrint:before {
      content: url("../assets/print.png");
      margin-right: 8px;
      vertical-align: middle;
    }
    #bReset {
      color: #00abfe;
      font-size: 16px;
      cursor: pointer;
      margin-right: 35px;
      font-family: "DINNextLTW01-Medium", Arial;
    }
    #bReset:before {
      content: url("../assets/clear.png");
      margin-right: 8px;
      vertical-align: middle;
    }
    .textlink {
        /*margin-left:48px;*/
        font-size: 12px;
        text-decoration: underline !important;
    }

    .fittingsTextLinks, .sensorsTextLinks {
        display: none;
        float: left;
        /*width: 580px;*/
    }

    #tPrint {
        display: none;
    }

    .col50 {
        width: 50%;
        float: left;
        margin-bottom: 4px;
    }

    .col30 {
        width: 30%;
        float: left;
    }

    .imgProduct {
        width: 128px;
        _float: left;
        text-align: center;
        margin-left: 20px;
    }

    .imgProduct .selected {
        border: 1px solid #000;
    }

    .prodFitting {
        min-width: 140px;
        margin-right: 10px;
        float: left;
        min-height: 230px;
        cursor: pointer;
    }

    .prodSensor {
        min-width: 140px;
        /*width:168px;*/
        margin-right: 10px;
        float: left;
        min-height: 240px;
        cursor: pointer;
    }

    .prodName {
        padding-top: 6px;
        text-align: center
    }

    .divToHighlight {
        float: left;
        width: 168px;
        height: 100%;
        padding: 8px;
    }

    .mycolumn {
        float: left;
        width: 29%;
        margin-right: 5%;
        display: inline-block;
    }

    .radiogroup {
        width: 91.7%;
        float: left;
        display: inline-block;
    }

    label {
        /*width:88%;*/
        display: inline-block;
    }

    #resultDiv {
        display: none;
    }

    #radiogruopSDR {
        display: none;
        /*margin-top: 6px;*/
    }

    .pLink {
        color: #F07C0B;
        font-size: 13px;
    }

    .radioLabelSmall {
        font-size: 9px;
        float: right;
        display: inline-block;
        width: 61%;
        line-height: 10px;
    }

    .radioLabelImg {
        float: left;
        margin-top: -6px;
    }

    .myhr {
        width: 100%;
        color: #aaa;
        display: block;
        height: 1px;
        border: 0;
        border-top: 1px solid #ccc;
        margin: 1em 0;
        padding: 0;
    }

    .myhrbig {
        width: 117%;
    }

    #sdgroupplaceholder {
        height: 34px;
        margin: 0;
        padding: 0;
        padding-top: 0px;
        display: none;
    }

    .fakeheight {
        display: none;
        height: 40px;
    }

    #psdgroupplaceholder {
        height: 60px;
        margin: 0;
        padding: 0;
    }

    input[type=radio] {
        float: left;
        display: inline-block;
    }

    .printLogo {
        display: none;
    }

    .flowValue {
        width: 21%;
        left: -4%;
        font-size: 1.4vw;
        max-font-size: 13px;
        position: absolute;
        text-align: right;
    }

    .pValue {
        width: 14%;
        top: 84%;
        font-size: 1.4vw;
        max-font-size: 13px;
        position: absolute;
        text-align: right;
    }

    .oAngle {
        /*width: 24%;*/
        top: 93%;
        left: 44%;
        font-size: 1.4vw;
        max-font-size: 13px;
        position: absolute;
        text-align: center;
    }

    .dFlow {
        width: 27%;
        top: 36%;
        left: -16%;
        position: absolute;
        font-size: 1.4vw;
        text-align: center;
        -moz-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
        -webkit-transform: rotate(-90deg);
    }
    .printHeader {
        font-weight: bold;;
    }
    /*@media (max-width: 788px) {*/
    @media screen and (max-width: 675px) {
        .hideMobile {
            display: none;
        }

        .mainLeft {
            width: 100%;
        }

        .infoI {
            margin-right: 4%;
        }

        .col50 {
            display: block;
            width: 100%;
        }

        .col30 {
            display: block;
            width: 100%;
        }

        .smallMobileMargin {
            margin-bottom: 5px;
        }

        .moreMobileMargin {
            margin-bottom: 20px;
        }

        .mainRight {
            width: 94%;
            margin-left: 3vw;
        }

        .tipp {
            left: -200px;
            max-width: 99%;
        }

        .flowValue, .pValue, .oAngle, .dFlow {
            font-size: 2.6vw;
        }

        .mycolumn {
            /*float:left;*/
            width: 91%;
            margin-right: 3%;
            display: inline-block;
        }

        .myblock {
            display: block;
            /*float: left;*/
            width: 100%;
            /*margin-right: 2%;*/
        }
        .row3 {
            margin: 0;
        }

    }


    @media screen and (max-width:670px) {
        .main {
            width:92%;
            margin: 0;
            /*padding:2px;*/
        }
        .halfRow {
            width:99%;
        }
        .row3 {
            width: 100%;
        }
        /*.pulldowns {*/
        /*  display: none;*/
        /*}*/
    }
    @media print {
        * {
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
        }

        .row {
            width: 100%;
        }

        mainp {
            margin: 0;
            padding: 0;
            width: 100%;
        }

        .flowValue, .pValue, .oAngle, .dFlow {
            font-size: 2.4vw;
        }

        h2 {
            font-family: "DINNextLTW01-Medium", sans-serif;
            /*margin-top: -12px !important;*/
            font-size: 25px;
            color: #0065A7;
        }

        .mainLeft {
            width: 50%;
            display: inline;
            float: left;
        }

        .mainRight {
            width: 50%;
            diplay: inline;
            margin-right: 0;
            /*float:right;*/
        }

        .printLogo {
            display: block;
            margin-left: 455px;
            margin-bottom: 20px;
        }

        .hidePrint {
            display: none;
        }

        .showPrint {
            display: block;
        }

        .pInline {
            display: inline !important;
            width: 100px !important;
            float: left !important;
        }

        .divShadow {
            border: 0 !important;
            -webkit-box-shadow: 0;
            -moz-box-shadow: 0;
            box-shadow: 0;
        }

        .pValue, .oAngle, .flowValue, .dFlow {
            font-size: 12px;
        }

        #pDiagramm {
            padding-left: 2%;
        }

    }
</style>
<style>
.multiselect {
  margin-top:10px;
}
    #app h2 {
        font-family: DINNextLTW05-Regular;
        font-size: 20px;
        color:#000000;
        margin-top: 0;
        line-height: unset;
    }
    #app .resultHeaderWrapper {
        display: table;
        font-family: DINNextLTW05-Regular;
        width: 100%;
        text-align: left;
        /*margin-bottom: 20px;*/
    }
    #app .resultHeader {
        border-top: 1px solid #bbb;
        border-left:0;
        border-right: 0;
        padding: 5px;
        display: flex;
        /*justify-content: center;*/
        align-items: center;
        width: 100%;
        cursor: pointer;
    }
    #app .resultImg {
        margin-left:10px;
        margin-right: 10px;
        width: 80px;
      margin-top:5px;
      margin-bottom: 5px;
    }
    #app .resultProductName {
        float: left;
        display: inline-block;
        font-size: 15px;
        font-family: DINNextLTW01-Medium;
    }
    #app .resultTable {
        width: 100%;
        font-size:14px;
        border-top:1px solid #bbb;
        display: none;
    }
    #app .resultTable th {
        text-align: left;
        height:50px;
    }
    #app .resultTable .resultTableRow0 {
        background-color: #F0F0F0;
        height:50px;
    }
    #app .resultTable .resultTableRow0 td{
        border-top:1px solid #bbb;
        border-bottom:1px solid #bbb;
    }
    #app .resultTable .resultTableRow1 {
        background-color: #FFFFFF;
        height:50px;
    }
    #app .resultTable a {
        color: #00AFFF !important;
        text-decoration: none;
        font-family: DINNextLTW01-Medium;
    }
    .myTooltip {
        background-color: #fff;
        border: 1px solid #999;
        color: #000;
        font-family: DINNextLTW05-Regular;
    }

    .tooltip-arrow {
        display: none !important;
        border-color: red;
    }
    @media screen and (max-width:544px) {
        #app .resultHeader {
            padding: 0 !important;
        }
        #app .main {
            padding:14px;
        }
        #sendEmail {
          /*display:none;*/
        }
    }
    @media print {
        .resultImg {
            display: block !important;
        }
      .row3 {
        width:44% !important;
      }
/*#sensorResults, #installationFittingResults {*/
/*  width: 10% !important;*/
/*}*/
      #app .resultTable {
        width: 44% !important;
      }
      #app .resultProductName {
        width:46%;
      }
      #text {
        display: none;
      }
    }
    @page
    {
        size:  A4;
        margin: 0px;
        margin-top:6px;
        margin-bottom:6px;
    }
</style>